module.exports = __webpack_public_path__ + "static/living-abroad-where-main-9882dc3c70e66f0065e10d5b6c3fa09a.jpg";